import React  from "react";

export default function TitreSection({
  content,
  subtitle,
  size, 
  inView, 
  reference, 
  align, 
  extraclass, 
  noMargin,
  fontCorps 
}) {
  var fontSize = ''
  switch (size) {
    case 2:
      fontSize = 'md:text-2xl'
      break;

    case 3:
      fontSize = 'md:text-3xl'
      break;
    case 4:
      fontSize = 'md:text-4xl'
      break;

    case 5:
      fontSize = 'md:text-5xl'
      break;

    default:
      break;
  }


  return (
    <div className={`${noMargin? '':'mb-8' } ${align? align :'' } ${extraclass? extraclass:'' } z-20 relative`}>
      <h2 className={`${noMargin? '':'mb-2' } text-4xl ${fontSize} ${reference ? 'md:opacity-0' : ''} ${fontCorps ? 'font-corps-med font-medium' : ''} ${inView ? 'animate' : ''}`} dangerouslySetInnerHTML={{ __html: content }}></h2>
      {
        subtitle ? <p className="text-sm"  dangerouslySetInnerHTML={{ __html: subtitle }}></p> : ''
      }
    </div>
  )
}
